import { formatDate } from '~/utils/dateFormatter';

export default ({ app }, inject) => {
  inject('formatDate', formatDate);
}
